import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useRestaurantContext } from "@/contexts/RestaurantContext";
import { toast } from "sonner";

export function usePeopleCountSettings() {
  const { activeRestaurant } = useRestaurantContext();
  const queryClient = useQueryClient();

  const { data: enabled = false, isLoading } = useQuery({
    queryKey: ["people-count-checkout-setting", activeRestaurant?.id],
    queryFn: async () => {
      if (!activeRestaurant?.id) return false;

      const { data, error } = await supabase
        .from("restaurants")
        .select("people_count_checkout_enabled")
        .eq("id", activeRestaurant.id)
        .single();

      if (error) {
        console.error("Error fetching people count setting:", error);
        return false;
      }

      return data?.people_count_checkout_enabled ?? false;
    },
    enabled: !!activeRestaurant?.id,
  });

  const mutation = useMutation({
    mutationFn: async (newValue: boolean) => {
      if (!activeRestaurant?.id) throw new Error("No active restaurant");

      const { error } = await supabase
        .from("restaurants")
        .update({ people_count_checkout_enabled: newValue })
        .eq("id", activeRestaurant.id);

      if (error) throw error;
      return newValue;
    },
    onSuccess: (newValue) => {
      queryClient.invalidateQueries({ queryKey: ["people-count-checkout-setting"] });
      toast.success(
        newValue
          ? "Confirmação de pessoas no checkout ativada"
          : "Confirmação de pessoas no checkout desativada"
      );
    },
    onError: (error) => {
      console.error("Error updating people count setting:", error);
      toast.error("Erro ao salvar configuração");
    },
  });

  return {
    peopleCountCheckoutEnabled: enabled,
    isLoading,
    updateSetting: mutation.mutate,
    isUpdating: mutation.isPending,
  };
}
